module.exports = __webpack_public_path__ + "img/senegal.35c31e0a.svg";